import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './inscription.css';

const Inscription = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // 🔥 NOUVEAU : Récupérer le type de certification depuis la navigation
    const [certificationType, setCertificationType] = useState(null); // 'PMP' ou 'PMICP' ou 'CAPM'

    // État initial SANS honeypot
    const [formData, setFormData] = useState({
        nom: '',
        prenoms: '',
        tel: '',
        email: '',
        profession: '',
        type_financement: '',
        diplome: '',
        code_promo: '',
        code_partenaire: '',
        entreprise: ''
    });

    const [eligibilityScore, setEligibilityScore] = useState(null);
    const [reference, setReference] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [success, setSuccess] = useState(false);
    const [redirectCountdown, setRedirectCountdown] = useState(5);
    const [errorState, setErrorState] = useState(null);

    // 🔥 FONCTION POUR RÉCUPÉRER LE SCORE SELON LA CERTIFICATION
    // const getEligibilityScore = (type) => {
    //     if (type === 'PMP') {
    //         const savedScore = localStorage.getItem('pmp_eligibility_score');
    //         if (savedScore) {
    //             try {
    //                 return JSON.parse(savedScore);
    //             } catch (error) {
    //                 console.error('Erreur lecture PMP:', error);
    //                 return null;
    //             }
    //         }
    //     } else if (type === 'PMICP') {
    //         const savedScore = localStorage.getItem('pmicp_eligibility_score');
    //         if (savedScore) {
    //             try {
    //                 return JSON.parse(savedScore);
    //             } catch (error) {
    //                 console.error('Erreur lecture PMI-CP:', error);
    //                 return null;
    //             }
    //         }
    //     }
    //     return null;
    // };

    const getEligibilityScore = (type) => {
        // Mapping des types de certification vers les clés localStorage
        const keyMap = {
            'PMP': 'pmp_eligibility_score',
            'PMICP': 'pmicp_eligibility_score',
            'CAPM': 'capm_eligibility_score'
        };

        const key = keyMap[type] || 'pmp_eligibility_score';
        const savedScore = localStorage.getItem(key);
        if (savedScore) {
            try {
                return JSON.parse(savedScore);
            } catch (error) {
                console.error(`Erreur lecture ${key}:`, error);
                return null;
            }
        }
        return null;
    };

    // 🔥 Récupérer le type de certification depuis location.state
    useEffect(() => {
        // Ne pas deviner ! Utiliser uniquement ce qui est envoyé
        if (location.state?.certificationType) {
            const certType = location.state.certificationType;
            setCertificationType(certType);

            // Afficher le nom complet de la certification
            const certNames = {
                'PMP': 'PMP',
                'PMICP': 'PMI-CP',
                'CAPM': 'CAPM'
            };
            const certName = certNames[certType] || certType;
            console.log(`📌 Certification reçue de la navigation: ${certName}`);

            // Récupérer le score pour cette certification
            const score = getEligibilityScore(certType);
            if (score) {
                setEligibilityScore(score);
                console.log(`📊 Score ${certName} récupéré:`, score);
            } else {
                console.log(`⚠️ Aucun score trouvé pour ${certName}`);
                setEligibilityScore(null);
            }
        } else {
            // Si aucune certification n'est envoyée, erreur ou redirection
            console.error("❌ Aucune certification spécifiée dans la navigation");
            setErrorState({
                message: "Aucune certification sélectionnée. Veuillez retourner à la page d'accueil."
            });
        }
    }, [location.state]);

    // // Récupérer le score du localStorage en fonction de la certification
    // useEffect(() => {
    //     const score = getEligibilityScore(certificationType);
    //     if (score) {
    //         setEligibilityScore(score);
    //         console.log(`📊 Score ${certificationType} récupéré:`, score);
    //     } else {
    //         console.log(`⚠️ Aucun score trouvé pour ${certificationType}`);
    //     }
    // }, [certificationType]);

    // // Récupérer le score du localStorage au chargement du composant
    // useEffect(() => {
    //     const savedScore = localStorage.getItem('pmp_eligibility_score');
    //     if (savedScore) {
    //         try {
    //             const scoreData = JSON.parse(savedScore);
    //             setEligibilityScore(scoreData);
    //             console.log('Score récupéré du localStorage:', scoreData);
    //         } catch (error) {
    //             console.error('Erreur lors de la lecture du score:', error);
    //         }
    //     }
    // }, []);

    // Récupérer la référence au montage
    // useEffect(() => {
    //     const initializeReference = () => { 
    //         try {
    //             // Vérifier si l'utilisateur arrive sans état de navigation
    //             if (!location.state?.formationReference) {
    //                 console.log("⚠️ Aucun state dans location, vérification du localStorage...");

    //                 // Essayer de récupérer depuis le localStorage
    //                 const savedReference = localStorage.getItem('pmp_formation_reference');
    //                 const savedSession = localStorage.getItem('pmp_session_data');

    //                 if (savedReference) {
    //                     console.log("✅ Référence récupérée du localStorage:", savedReference);
    //                     setReference(savedReference);
    //                 } else {
    //                     console.error("❌ Aucune référence trouvée, redirection vers l'accueil");
    //                     setErrorState({
    //                         message: "Aucune formation sélectionnée. Veuillez retourner à la page d'accueil et sélectionner une formation."
    //                     });
    //                     // Optionnel: rediriger après 5 secondes
    //                     setTimeout(() => {
    //                         navigate('/');
    //                     }, 5000);
    //                 }
    //             } else {
    //                 // SIMPLIFICATION: Prendre directement la référence sans décodage
    //                 const formationReference = location.state.formationReference;
    //                 console.log("✅ Référence reçue directement:", formationReference);

    //                 if (formationReference) {
    //                     setReference(String(formationReference));
    //                     console.log("✅ Référence stockée pour l'envoi:", formationReference);

    //                     // Sauvegarder dans localStorage au cas où
    //                     localStorage.setItem('pmp_formation_reference', String(formationReference));
    //                 } else {
    //                     setErrorState({
    //                         message: "Impossible de récupérer les informations de la formation. Veuillez réessayer."
    //                     });
    //                 }
    //             }
    //         } catch (error) {
    //             console.error("❌ Erreur lors de l'initialisation:", error);
    //             setErrorState({
    //                 message: "Une erreur est survenue lors du chargement. Veuillez rafraîchir la page."
    //             });
    //         }
    //     };

    //     initializeReference();
    //     window.scrollTo(0, 0);
    // }, [location, navigate]);

    useEffect(() => {
        const initializeReference = () => {
            try {
                if (!location.state?.formationReference) {
                    console.log("⚠️ Aucun state dans location, vérification du localStorage...");

                    const savedReference = localStorage.getItem('pmp_formation_reference');
                    const savedSession = localStorage.getItem('pmp_session_data');

                    if (savedReference) {
                        console.log("✅ Référence récupérée du localStorage:", savedReference);
                        setReference(savedReference);
                    } else {
                        console.error("❌ Aucune référence trouvée, redirection vers l'accueil");
                        setErrorState({
                            message: "Aucune formation sélectionnée. Veuillez retourner à la page d'accueil et sélectionner une formation."
                        });
                        setTimeout(() => {
                            navigate('/');
                        }, 5000);
                    }
                } else {
                    const formationReference = location.state.formationReference;
                    console.log("✅ Référence reçue directement:", formationReference);

                    if (formationReference) {
                        setReference(String(formationReference));
                        localStorage.setItem('pmp_formation_reference', String(formationReference));
                    } else {
                        setErrorState({
                            message: "Impossible de récupérer les informations de la formation. Veuillez réessayer."
                        });
                    }
                }
            } catch (error) {
                console.error("❌ Erreur lors de l'initialisation:", error);
                setErrorState({
                    message: "Une erreur est survenue lors du chargement. Veuillez rafraîchir la page."
                });
            }
        };

        initializeReference();
        window.scrollTo(0, 0);
    }, [location, navigate]);

    // Gestion du compte à rebours pour la redirection
    useEffect(() => {
        let timer;
        if (success && redirectCountdown > 0) {
            timer = setTimeout(() => {
                setRedirectCountdown(prev => prev - 1);
            }, 1000);
        } else if (success && redirectCountdown === 0) {
            navigate('/');
        }
        return () => clearTimeout(timer);
    }, [success, redirectCountdown, navigate]);


    const [emailError, setEmailError] = useState('');
    // Fonction de validation d'email
    const validateEmail = (email) => {
        if (!email) return false;

        // Regex standard pour validation email
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Vérifications supplémentaires
        if (!emailRegex.test(email)) return false;

        // Vérifier la longueur (max 254 caractères)
        if (email.length > 254) return false;

        // Vérifier qu'il n'y a pas de caractères consécutifs interdits
        if (email.includes('..')) return false;

        // Vérifier que le domaine a un point
        const domain = email.split('@')[1];
        if (!domain || !domain.includes('.')) return false;

        // Vérifier que le TLD a au moins 2 caractères
        const tld = domain.split('.').pop();
        if (!tld || tld.length < 2) return false;

        return true;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        if (name === 'email') {
            if (value && !validateEmail(value)) {
                setEmailError('Email invalide (ex: nom@domaine.com)');
            } else {
                setEmailError('');
            }
        }
    };

    const handlePhoneChange = (value) => {
        console.log("📞 Valeur téléphone reçue:", value);

        if (!value) {
            setPhoneError('Le numéro de téléphone est requis');
            setFormData(prev => ({
                ...prev,
                tel: '',
            }));
            return;
        }

        // Nettoyer la valeur (enlever les espaces)
        const cleanedValue = value.replace(/\s/g, '');


        // Vérifier si c'est un numéro du Bénin (+229)
        if (cleanedValue.startsWith('+229')) {
            const numericValue = cleanedValue.replace(/\D/g, '');

            // Forcer le format 22901 pour le Bénin
            if (numericValue.startsWith('229') && numericValue.length < 5) {
                const userDigits = numericValue.replace(/^229/, '').replace(/^0?/, '').slice(0, 8);
                setFormData(prev => ({
                    ...prev,
                    tel: '+22901' + userDigits
                }));
                return;
            }

            // Limiter à 13 chiffres + le signe +
            if (numericValue.length > 13) {
                const limitedValue = numericValue.slice(0, 13);
                setFormData(prev => ({
                    ...prev,
                    tel: '+' + limitedValue
                }));
                return;
            }
        }

        setFormData(prev => ({
            ...prev,
            tel: cleanedValue
        }));
    };

    // 🔥 Gestion du changement de pays
    const handleCountryChange = (country) => {
        console.log("📞 Changement de pays:", country);

        // Si le pays est le Bénin (code +229)
        if (country && country === 'BJ') {
            // Forcer le format 22901 pour le Bénin
            const currentNumeric = formData.tel.replace(/\D/g, '');
            if (!currentNumeric.startsWith('22901') && currentNumeric.length > 0) {
                const userDigits = currentNumeric.replace(/^229/, '').replace(/^0?/, '').slice(0, 8);
                setFormData(prev => ({
                    ...prev,
                    tel: '+22901' + userDigits
                }));
            } else if (!currentNumeric) {
                // Si le champ est vide, initialiser avec 22901
                setFormData(prev => ({
                    ...prev,
                    tel: '+22901'
                }));
            }
        }
    };

    // 🔥 FONCTION DE VALIDATION DU TÉLÉPHONE PAR PAYS
    const validatePhoneByCountry = (phone, country) => {
        const numericValue = phone.replace(/\D/g, '');

        // Bénin (+229)
        if (phone.startsWith('+229')) {
            return {
                isValid: numericValue.length === 13 && numericValue.startsWith('22901'),
                message: 'Le numéro Bénin doit être au format 22901XXXXXXXX (13 chiffres)'
            };
        }

        // Autres pays
        return {
            isValid: numericValue.length >= 8,
            message: 'Le numéro doit contenir au moins 8 chiffres'
        };
    };

    // 🔥 Initialisation du champ avec 22901 au montage
    useEffect(() => {
        if (!formData.tel) {
            setFormData(prev => ({ ...prev, tel: '+22901' }));
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("=== DÉBUT SOUMISSION FORMULAIRE ===");
        console.log("Données complètes:", formData);
        console.log("Référence:", reference);
        console.log("Timestamp:", new Date().toISOString());

        // Validation normale
        if (!formData.email || !validateEmail(formData.email)) {
            setEmailError('Veuillez entrer une adresse email valide');
            setMessage('Adresse email invalide');
            return;
        }

        if (!formData.tel || !formData.tel.startsWith('+')) {
            setPhoneError('Veuillez entrer un numéro de téléphone valide avec indicatif pays');
            return;
        }

        const phoneValidation = validatePhoneByCountry(formData.tel);
        if (!phoneValidation.isValid) {
            setPhoneError(phoneValidation.message);
            setMessage('Numéro de téléphone invalide');
            return;
        }

        if (formData.type_financement === 'Entreprise' && !formData.entreprise.trim()) {
            setMessage('Veuillez saisir le nom de l\'entreprise');
            return;
        }

        if (!reference) {
            setMessage('❌ Erreur: Aucune formation sélectionnée.');
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            // PRÉPARATION DES DONNÉES - SANS HONEYPOT
            const submissionData = {
                nom: formData.nom.trim(),
                prenoms: formData.prenoms.trim(),
                telephone: formData.tel.trim().replace(/\s/g, ''),
                email: formData.email.trim(),
                profession: formData.profession.trim(),
                type_financement: formData.type_financement,
                diplome: formData.diplome,
                code_promo: formData.code_promo || '',
                code_partenaire: formData.code_partenaire || '',
                entreprise: formData.entreprise.trim() || '',
                reference: reference,
                certification_type: certificationType
                // PAS DE website (honeypot) NI submit_time !
            };

            // Ajouter les données du score si disponibles
            if (eligibilityScore) {
                submissionData.eligibility_score = eligibilityScore.score;
                submissionData.eligibility_niveau = eligibilityScore.niveau;
                submissionData.eligibility_date = eligibilityScore.date;

                const certificationLabels = {
                    'PMP': 'PMP',
                    'PMICP': 'PMI-CP',
                    'CAPM': 'CAPM'
                };
                submissionData.certification = certificationLabels[certificationType] || certificationType;
                if (eligibilityScore.formData) {
                    submissionData.eligibility_responses = eligibilityScore.formData;
                }
            }

            console.log("✅ Données envoyées au backend:", JSON.stringify(submissionData, null, 2));

            const response = await fetch(process.env.REACT_APP_API_URL + '/enregistrer-inscription/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(submissionData),
            });

            console.log("📤 Réponse HTTP:", response.status, response.statusText);

            const textResponse = await response.text();
            console.log("📥 Réponse brute:", textResponse);

            let result;
            try {
                result = JSON.parse(textResponse);
            } catch (parseError) {
                console.error("❌ Erreur de parsing JSON:", parseError);
                throw new Error('Réponse serveur invalide');
            }

            console.log("✅ Réponse parsée:", result);

            if (response.ok) {
                // VÉRIFIER SI C'EST UN VRAI SUCCÈS
                if (result.fake === true) {
                    console.log("⚠️ Bot détecté par le backend (fake response)");
                    console.log("Détails:", {
                        response: result,
                        dataSent: submissionData
                    });

                    // Message générique sans succès
                    setMessage('Merci pour votre intérêt. Notre équipe vous contactera prochainement.');

                    // Nettoyer après 3 secondes
                    setTimeout(() => {
                        setFormData({
                            nom: '', prenoms: '', tel: '', email: '',
                            profession: '', type_financement: '', diplome: '', code_promo: '', code_partenaire: '', entreprise: ''
                        });
                        setEligibilityScore(null);
                        setMessage('');
                    }, 3000);
                } else {
                    // VRAI SUCCÈS
                    setMessage('Inscription réussie !');
                    setSuccess(true);

                    // Réinitialiser
                    setFormData({
                        nom: '', prenoms: '', tel: '', email: '',
                        profession: '', type_financement: '', diplome: '', code_promo: '', code_partenaire: '', entreprise: ''
                    });
                    setEligibilityScore(null);

                    // Démarre le compte à rebours
                    setRedirectCountdown(5);
                }
            } else {
                const errorMsg = result.error || result.message || `Erreur ${response.status}`;
                setMessage(`Erreur: ${errorMsg}`);
                console.error("❌ Erreur serveur:", result);
            }
        } catch (error) {
            console.error('❌ Erreur:', error);
            setMessage('Erreur de connexion au serveur. Vérifiez votre connexion internet.');
        } finally {
            setLoading(false);
        }
    };

    // Si état d'erreur
    if (errorState) {
        return (
            <div className="bg-light min-vh-100 d-flex justify-content-center align-items-center">
                <div className="container d-flex flex-column justify-content-center min-vh-100 py-4">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6">
                            <div className="ibox-content p-4 rounded bg-white shadow-sm text-center">
                                <div className="mb-4">
                                    <i className="bi bi-exclamation-triangle-fill text-warning fa-5x"></i>
                                </div>
                                <h3 className="font-bold text-warning">Erreur de chargement</h3>
                                <p className="text-muted mb-4">{errorState.message}</p>
                                <div className="d-flex justify-content-center gap-3">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => window.location.reload()}
                                    >
                                        Rafraîchir la page
                                    </button>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => navigate('/')}
                                    >
                                        Retour à l'accueil
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Si succès, afficher le message de succès avec compte à rebours
    if (success) {
        return (
            <div className="bg-light min-vh-100 d-flex justify-content-center align-items-start">
                <div className="container d-flex flex-column justify-content-center min-vh-100 py-4">
                    <div className="row justify-content-center flex-grow-1">
                        <div className="col-md-10 col-lg-8 d-flex flex-column">
                            <div className="text-center loginscreen animated fadeInDown flex-grow-1 d-flex flex-column justify-content-center">
                                <div className="ibox-content p-4 rounded bg-white shadow-sm text-center">
                                    <div className="mb-4">
                                        <i className="bi bi-check-circle-fill text-success fa-5x"></i>
                                    </div>
                                    <h3 className="font-bold text-success">Inscription réussie !</h3>
                                    <p className="text-muted mb-4">Merci pour votre inscription</p>
                                    <p>Notre équipe prendra contact avec vous dans les plus brefs délais.</p>
                                    <hr />
                                    <p className="mb-0">
                                        Redirection dans <strong>{redirectCountdown}</strong> secondes...
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Sinon afficher le formulaire normal
    return (
        <div className="bg-light min-vh-100 d-flex justify-content-center align-items-start">
            <div className="container d-flex flex-column justify-content-center min-vh-100 py-4">
                <div className="row justify-content-center flex-grow-1">
                    <div className="col-md-10 col-lg-8 d-flex flex-column">
                        <div className="text-center loginscreen animated fadeInDown flex-grow-1 d-flex flex-column justify-content-center">
                            <div className="ibox-content p-4 rounded bg-white shadow-sm" style={{ textAlign: "left" }}>

                                <h3 className="font-bold">Formulaire d'inscription</h3>
                                <p className="text-muted">Veuillez entrer vos informations</p>

                                {/* Afficher le score récupéré si disponible */}


                                {message && (
                                    <div className={`alert ${message.includes('réussie') ? 'alert-success' : 'alert-danger'} row justify-content-between position-relative m-1`}>
                                        {message}
                                    </div>
                                )}

                                <form className="m-t" role="form" onSubmit={handleSubmit}>
                                    {/* PAS DE CHAMP HONEYPOT CACHÉ */}

                                    {/* Ligne 1 - Nom et Prénom */}
                                    <div className="form-row">
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Nom <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control-custom"
                                                placeholder="Votre nom"
                                                required
                                                name="nom"
                                                value={formData.nom}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Prénom(s) <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control-custom"
                                                placeholder="Vos prénoms"
                                                required
                                                name="prenoms"
                                                value={formData.prenoms}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Ligne 2 - Téléphone et Email */}
                                    <div className="form-row">
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Téléphone <span className="text-danger">*</span>
                                            </label>
                                            <div className="phone-input-wrapper">
                                                <PhoneInput
                                                    international
                                                    defaultCountry="BJ"
                                                    value={formData.tel}
                                                    onChange={handlePhoneChange}
                                                    onCountryChange={handleCountryChange}
                                                    required
                                                    // countries={['BJ', 'TG', 'CI', 'SN', 'FR']}
                                                    placeholder="+229 XX XX XX XX XX"
                                                    onKeyDown={(e) => {
                                                        // 🔥 Si le pays est Bénin, bloquer après 13 chiffres
                                                        const currentValue = formData.tel;
                                                        if (currentValue && currentValue.startsWith('+229')) {
                                                            const numericValue = currentValue.replace(/\D/g, '');

                                                            // Si déjà 13 chiffres, bloquer les nouvelles touches (sauf navigation)
                                                            if (numericValue.length >= 13) {
                                                                // Autoriser les touches de navigation
                                                                const navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
                                                                if (!navigationKeys.includes(e.key) && !e.ctrlKey && !e.metaKey) {
                                                                    e.preventDefault();
                                                                    // setPhoneError('Nombre maximum de 13 chiffres atteint');
                                                                }
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {phoneError && (
                                                <div className="text-danger small mt-1">{phoneError}</div>
                                            )}
                                        </div>
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Email <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control-custom"
                                                placeholder="Votre email"
                                                required
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            {emailError && (
                                                <div className="text-danger small mt-1">
                                                    {emailError}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Ligne 3 - Profession et Diplôme */}
                                    <div className="form-row">
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Profession <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control-custom"
                                                placeholder="Votre profession"
                                                required
                                                name="profession"
                                                value={formData.profession}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Diplôme <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control-custom"
                                                required
                                                name="diplome"
                                                value={formData.diplome}
                                                onChange={handleChange}
                                            >
                                                <option value="">Sélectionnez votre diplôme</option>
                                                <option value="BAC">BAC</option>
                                                <option value="BTS">BTS</option>
                                                <option value="Licence">Licence</option>
                                                <option value="Master1">Master1</option>
                                                <option value="Master2">Master2</option>
                                                <option value="Doctorat">Doctorat</option>
                                                <option value="Ingénieur">Ingénieur</option>
                                                <option value="Autres">Autres</option>
                                            </select>
                                        </div>
                                    </div>

                                    {/* Ligne 4 - Code promo et partenaire */}
                                    <div className="form-row">
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Code promo <span className="text-danger"></span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control-custom"
                                                placeholder="Votre code promo"
                                                name="code_promo"
                                                value={formData.code_promo}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Code partenaire <span className="text-danger"></span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control-custom"
                                                placeholder="Votre code partenaire"
                                                name="code_partenaire"
                                                value={formData.code_partenaire}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Ligne 5 - Type de financement */}
                                    <div className="form-row">
                                        <div className="form-group text-left">
                                            <label className="form-label">
                                                Type de financement <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control-custom"
                                                required
                                                name="type_financement"
                                                value={formData.type_financement}
                                                onChange={handleChange}
                                            >
                                                <option value="">Sélectionnez le type de financement</option>
                                                <option value="Particulier">Particulier</option>
                                                <option value="Entreprise">Entreprise</option>
                                            </select>
                                        </div>

                                        {/* Champ Entreprise conditionnel */}
                                        {formData.type_financement === 'Entreprise' && (
                                            <div className="form-group text-left">
                                                <label className="form-label">
                                                    Nom de l'entreprise <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control-custom"
                                                    placeholder="Nom de votre entreprise"
                                                    required
                                                    name="entreprise"
                                                    value={formData.entreprise}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-buttons-container">
                                        <button
                                            type="button"
                                            className="btn btn-default-custom"
                                            onClick={() => {
                                                setFormData({
                                                    nom: '',
                                                    prenoms: '',
                                                    tel: '',
                                                    email: '',
                                                    profession: '',
                                                    type_financement: '',
                                                    diplome: '',
                                                    code_promo: '',
                                                    code_partenaire: '',
                                                    entreprise: ''
                                                });
                                                setPhoneError('');
                                                setMessage('');
                                            }}
                                        >
                                            Effacer
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success-custom d-flex align-items-center justify-content-center gap-2"
                                            disabled={loading || !reference}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Enregistrement...
                                                </>
                                            ) : 'Enregistrer'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Inscription;